import React from 'react'

const Backend = () => {
  return (
    <div className="skills__content">
    <h3 className="skills__title">Backend Development</h3>
    
    <div className="skills__box">
        <div className="skill__group">
            <div className="skills__data">
                <i class='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">ExpressJs</h3>
                    <span className="skills__level">Basics</span>
                </div>
            </div>

            <div className="skills__data">
                <i class='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">RESTful</h3>
                    <span className="skills__level">Basics</span>
                </div>
            </div>

            <div className="skills__data">
                <i class='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">MySQL</h3>
                    <span className="skills__level">Basics</span>
                </div>
            </div>
        </div>

        <div className="skill__group">
            <div className="skills__data">
                <i class='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">Spring/Boot</h3>
                    <span className="skills__level">Basics</span>
                </div>
            </div>

            <div className="skills__data">
                <i class='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">Firebase</h3>
                    <span className="skills__level">Basics</span>
                </div>
            </div>

            <div className="skills__data">
                <i class='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">Flutter</h3>
                    <span className="skills__level">Basics</span>
                </div>
            </div>
        </div>
    </div>
   </div>
  )
}

export default Backend
